import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import classnames from 'classnames';
import { InfoTooltip } from 'Shared/components';
import { ETooltipPlacement, ETooltipAction, ETooltipAlign, } from 'Shared/components/Tooltip/consts';
import InfoIconDisabled from 'Shared/assets/icons/info.svg';
import NavIcon from 'Shared/assets/icons/nav.svg';
import { EIconType } from '../../consts';
import styles from './NavigationButtonIcon.css';
export const NavigationButtonIcon = memo(function QQPlotButtonIcon(props) {
    const { id, iconType, title } = props;
    if (iconType === EIconType.Enabled) {
        return (_jsx("span", Object.assign({ className: classnames(styles.info, styles.enabled) }, { children: _jsx(NavIcon, {}, void 0) }), void 0));
    }
    return (_jsx("span", Object.assign({ className: classnames(styles.info, styles.disabled) }, { children: _jsx(InfoTooltip, Object.assign({ align: ETooltipAlign.End, targetEvent: ETooltipAction.Hover, position: ETooltipPlacement.BottomRight, id: id, icon: _jsx(InfoIconDisabled, {}, void 0), overlayClassName: styles.infoTooltip }, { children: title }), void 0) }), void 0));
});
